enum PortalRole {
    Unauthenticated = 'unauthenticated',
    User = 'user',
    Admin = 'admin'
}

export default PortalRole
